module.exports = __webpack_public_path__ + "static/Our Kettle-db4398dbf69ecd3bc9a050e06792a737.jpg";